import React, { useContext, useRef, useMemo, useState } from 'react';
import { Context } from '@front10/helpers/dist/Context';
import { Icon, ThemeProvider } from '@front10/base-elements';
import { EmotionCache } from '../../containers/_commons/emotionCache';
/**
 * Atoms
 */
import { Listbox } from '../../lab/Listbox';
import Box from '../../elements/Box';
import { FilterButton } from '../../lab/FilterButton';
import { Panels } from '../../containers/VerticalBookingContainer/Panels';
import { FlexibleFilterContainer } from '../../lab/FlexibleFilterContainer';

/**
 * Hooks
 */
import { useIsMobileView } from '@front10/utils';

const FlightStopCountFilter = (props, ref) => {
  const {
    value,
    labelKey = 'cmp-location-selector-label-number-stops',
    options = [
      { label: 'cmp-stops-options-any', value: 'Any' },
      { label: 'cmp-stops-options-upto', value: '1' },
      { label: 'cmp-stops-options-non', value: '0' }
    ],
    disabled,
    mobileView = false,
    onChange,
    filterButtonIconProps,
    menuContainer = {
      'cmp-styles': {
        width: '100%'
      }
    },
    itemContainer = {
      'cmp-styles': {
        height: '50px',
        'line-height': '50px',
        'border-bottom': '1px solid rgba(0,0,0,.125)'
      }
    },
    selectedItem = {
      'font-weight': 'bold',
      'padding-right': '10px'
    },
    item = {
      'font-weight': 'normal',
      'padding-right': '10px'
    },
    iconCheckProps = {}
  } = props;

  const {
    translate,
    direction,
    theme: { designTokens }
  } = useContext(Context);

  const title = translate('cmp-number-stops-title', 'Number of Stops');
  const valueTranslated = useMemo(() => {
    return options
      .filter((option) => option.value === value)
      .map((option) => {
        return translate(option.label);
      })
      .pop();
  }, [options, translate, value]);

  const numberStopsOptions = useMemo(() => {
    return (Array.isArray(options) ? options : []).map((option) => ({
      ...option,
      label: translate(option.label)
    }));
  }, [options, translate]);

  const [numberStopsFilter, setNumberStops] = useState(value);
  const flexibleRef = React.useRef();

  React.useEffect(() => {
    setNumberStops(value);
  }, [value]);

  let isMobile = useIsMobileView();
  if (mobileView) {
    isMobile = true;
  }

  const listboxRef = useRef(null);

  React.useImperativeHandle(
    ref,
    () => ({
      focusToggleElement: () => {
        listboxRef.current.focusToggleElement();
      }
    }),
    []
  );

  const handleSave = (value1) => {
    props.onChange({ value: value1 });
    flexibleRef.current.save();
  };

  const desktopLayout = (
    <Listbox
      ref={listboxRef}
      label={translate(labelKey, 'Select Number of Stops')}
      placeholder={title}
      options={numberStopsOptions}
      defaultValue={value}
      forcePlaceholder={disabled}
      focusWhenIsShow={false}
      disabled={disabled}
      onChange={(value) => onChange({ value })}
      filterButtonIconProps={filterButtonIconProps}
    />
  );

  const mobileLayout = (
    <FlexibleFilterContainer
      ref={flexibleRef}
      showSeparator
      saveOnClose={false}
      variant="layout.popover"
      label={title}
      title={title}
      displayFooter={false}
      toggleElement={
        <FilterButton
          iconSettings={filterButtonIconProps}
          value={value && !disabled ? `${valueTranslated} ` : title}
          aria-label={`${title} ${value ? valueTranslated : ''}`}
          active={Boolean(value)}
          disabled={disabled} // used to disabled the component
        />
      }
    >
      <Panels showSeparator={false}>
        <Box {...menuContainer}>
          {options.map((option) => (
            <Box {...itemContainer}>
              <Box onClick={() => handleSave(option.value)}>
                <Icon
                  className="fr-rotate"
                  icon="check"
                  size={20}
                  sx={{
                    stroke: 'primary',
                    verticalAlign: 'middle',
                    strokeWidth: '2px',
                    visibility: numberStopsFilter === option.value ? 'visible' : 'hidden'
                  }}
                  {...iconCheckProps}
                ></Icon>
                {/* <CheckIcon
                  className="fr-rotate"
                  size={17}
                  sx={{
                    stroke: 'primary',
                    strokeWidth: '1px',
                    width: '25px',
                    height: '25px',
                    verticalAlign: '-webkit-baseline-middle',
                    visibility: numberStopsFilter === option.value ? 'visible' : 'hidden'
                  }}
                /> */}
                <span style={numberStopsFilter === option.value ? selectedItem : item}>
                  {translate(option.label)}
                </span>
              </Box>
            </Box>
          ))}
        </Box>
      </Panels>
    </FlexibleFilterContainer>
  );

  return (
    <EmotionCache direction={direction}>
      <ThemeProvider theme={designTokens}>{!isMobile ? desktopLayout : mobileLayout}</ThemeProvider>
    </EmotionCache>
  );
};

export default React.forwardRef(FlightStopCountFilter);
